<template>
    <div class="TopNav">
        <slot name="navigation">
            <RPNavigation
                :active-section="activeSection"
                :subsections="subsections"
                :active-subsection="activeSubsection"
                @navigate="to => $emit('navigate', to)"
            />
        </slot>


        <div class="TopNav__search">
            <slot name="search"></slot>
        </div>


        <ProfileBar
            :user-profile="userProfile"
            :reports="reports"
            :notifications="notifications"
            @nav-to-profile="$emit('nav-to-profile')"
            @sign-out="e => $emit('sign-out', e)"
            @report="r => $emit('report', r)"
            @notification="n => $emit('notification', n)"
            @download="d => $emit('download', d)"
            @notification-page="$emit('notification-page')"
            @delete-notification="id => $emit('delete-notification', id)"
        >
            <template v-slot:profile>
                <slot name="profile"></slot>
            </template>
            <template v-slot:notifications>
                <slot name="notifications"></slot>
            </template>
            <template v-slot:help>
                <slot name="help"></slot>
            </template>
        </ProfileBar>
    </div>
</template>

<script>
import ProfileBar from './TopNav/ProfileBar.vue';
import RPNavigation from './TopNav/RPNavigation/RPNavigation.vue';

export default {
    name: 'RPTopNav',
    components: {
        ProfileBar,
        RPNavigation,
    },
    props: {
        /**
         * See `RPDashboardLayout` for prop details
         */
        activeSection: {
            type: Object,
            default: () => ({})
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        subsections: {
            type: Array,
            default: () => ({})
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        activeSubsection: {
            type: Object,
            default: () => ({})
        },
        reports: {
            type: Array,
            default: () => ([])
        },
        notifications: {
            type: Array,
            default: () => ([])
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        userProfile: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss">
    .TopNav {
        background: $white;
        color: $grey-600;
        position: relative;
        height: 3.5rem;
        @include shadow("extra-low");
        display: grid;
        grid-template-columns: min-content auto min-content;
        column-gap: 1rem;
        z-index: 999999;
        &__search{
            display: flex;
            align-items: center;
        }
    }
</style>